// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class NextStepNavigationModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }
}
